import type { FileDto } from '@viastud/server/services/file_service'

import { fileDtoToFile } from '#lib/file-utils'
import { trpc, vanillaTrpc } from '#lib/trpc'

export const useUploadFile = () => {
  const trpcMutation = trpc.file.upload.useMutation()

  const uploadFile = async (file: FileDto) => {
    const data = await fileDtoToFile(file)
    const response = await trpcMutation.mutateAsync({
      fileName: file.name,
      fileId: file.id,
      contentType: data.type,
    })
    const uploadResponse = await fetch(response.url, {
      method: 'PUT',
      body: data,
      headers: {
        'Content-Type': data.type,
      },
    })
    if (!uploadResponse.ok) {
      throw new Error(`File upload failed (${uploadResponse.status})`)
    }

    return vanillaTrpc.file.get.query({ fileId: response.fileId })
  }

  const uploadFiles = async (files: FileDto[]) => {
    const uploadedFiles: FileDto[] = []

    for (const file of files) {
      const fileDto = await uploadFile(file)
      uploadedFiles.push(fileDto)
    }

    return uploadedFiles
  }

  return { uploadFile, uploadFiles }
}
